module.exports = __webpack_public_path__ + "static/media/power-of-algorithm.9db6c54e.svg";